export interface OpenIDConfiguration {
  authorizationEndpoint: string;
  tokenEndpoint: string;
  endSessionEndpoint: string;
  displayValuesSupported: Array<string>;
  codeChallengeMethods: Array<string>;
}